/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wc_Common_On_This_PageInputs */

const en_wc_common_on_this_page = /** @type {(inputs: Wc_Common_On_This_PageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`On this page`)
};

/**
* | output |
* | --- |
* | "On this page" |
*
* @param {Wc_Common_On_This_PageInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const wc_common_on_this_page = /** @type {((inputs?: Wc_Common_On_This_PageInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wc_Common_On_This_PageInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_wc_common_on_this_page(inputs)
});
export { wc_common_on_this_page as "wc.common.on_this_page" }